<template>
    <div class="certificate">
        <div class="top">
            <base-divider text="证书"/>
        </div>
        <span class="download" v-if="certificates.length > 0">
            <el-button
                    @click="handlePdfLink(certificates[0].filePath, '证书')"
                    type="primary"
                    size="small"
            >
                下载证书
            </el-button>
        </span>
        <div class="img-box" center>
            <img :src="userInfo.certificateUrl" alt="">
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import {getCertificate, getUserInfo} from '@/http/request'
    import BaseDivider from "../../../components/BaseDivider/BaseDivider"

    export default {
        name: "certificate",
        components: {BaseDivider},
        data() {
            return {
                certificates: []
            }
        },
        computed: {
            ...mapState(['userInfo'])
        },
        created() {
            this.getCertificate()
        },
        methods: {
            ...mapActions(['setUserInfo']),

            getCertificate() {
                const loading = this.$loading({
                    text: '请稍后',
                    fullscreen: true,
                    background: 'rgba(0, 0, 0, 0.7)',
                    lock: true
                })
                getCertificate().then(({data}) => {
                    loading.close();
                    if (data.code === 0) {
                        this.certificates = data.data;
                        this.getUserInfo();
                    } else {
                        this.$message({
                            type: 'success',
                            message: data.msg
                        })
                    }
                })
            },

            // 获取个人信息
            getUserInfo() {
                getUserInfo().then(({data}) => {
                    if (data.code === 0) {
                        this.setUserInfo(data.data)
                    } else {
                        this.$message({
                            type: 'success',
                            message: data.msg
                        })
                    }
                })
            },

            handleFileDownload (url, filename) {
                // 创建 a 标签
                let a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
            },

            handlePdfLink (url, filename) {
                fetch(url, {
                    method: 'get',
                    responseType: 'arraybuffer',
                })
                .then(function (res) {
                    if (res.status !== 200) {
                        return res.json()
                    }
                    return res.arrayBuffer()
                })
                .then((blobRes) => {
                    // 生成 Blob 对象，设置 type 等信息
                    const e = new Blob([blobRes], {
                        type: 'application/octet-stream',
                        'Content-Disposition':'attachment'
                    })
                    // 将 Blob 对象转为 url
                    const link = window.URL.createObjectURL(e)
                    this.handleFileDownload(link, filename)
                }).catch(err => {
                    console.error(err)
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .certificate {
        .top {
            margin-bottom: 50px;
        }
        .img-box {
            width: 500px;
        }
        .download {
            float: right;
        }
    }
</style>